(function(){
  "use strict";

  angular.module('irricrops')

    .controller('HomeCtrl', ['$rootScope','$log','$timeout','$location','menu','$scope','Config', 'TUTORIAL_DIC',
      '$mdBottomSheet','$mdSidenav','$q','$window','CONSTANTES','global','$state','Auth','temporadaFac','selectionToolbar',
      function ($rootScope, $log, $timeout, $location, menu, $scope, Config, TUTORIAL_DIC,
        $mdBottomSheet, $mdSidenav, $q, $window, CONSTANTES, global, $state, Auth, temporadaFac, selectionToolbar) {

      $scope.temporadaFac = temporadaFac;
      $scope.TUTORIAL_DIC = TUTORIAL_DIC

        $scope.config           = Config;
        $scope.global           = global;
        $scope.selectionToolbar = selectionToolbar;
        $scope.confScroll       = {
            axis          : 'y',   // Vertical or horizontal scrollbar? ( x || y ).
            wheel         : true,  // Enable or disable the mousewheel;
            wheelSpeed    : 40,    // How many pixels must the mouswheel scroll at a time.
            wheelLock     : true,  // Lock default scrolling window when there is no more content.
            scrollInvert  : false, // Enable invert style scrolling
            trackSize     : false, // Set the size of the scrollbar to auto or a fixed number.
            thumbSize     : false, // Set the size of the thumb to auto or a fixed number.
            alwaysVisible : false, // Set to false to hide the scrollbar if not being used
            autoUpdate    : true   // Autoupdate the scrollbar if DOM changes. Needs MutationObserver or a polyfill to be available
        };
      /************************
       * TABS para cada vista *
       ************************/

      $scope.tabsVinedo = function(id){
        global.tabs = [

                      /* {
                        state: 'vinedo.inicio',
                        itemId: id,
                        label:'inicio',
                        visible:{
                          // mode: "produccion", //o tambien riego
                          config:'vistaInicio'
                        }
                      },*/

                      {
                        state: 'vinedo.resumen',
                        itemId: id,
                        label:'Resumen',
                        visible:{
                          // permission: 'ver-vinedo-et'
                          // mode: "riego",
                        }
                      },

                      {
                        state: 'vinedo.newtimeline',
                        itemId: id,
                        label:'Planilla',
                        visible:{
                          // permission: 'ver-vinedo-et'
                          // mode: "riego",
                        }
                      },

                      /*{
                        state: 'vinedo.timeline',
                        itemId: id,
                        label:'Timeline',
                        visible:{
                          // permission: 'ver-vinedo-et'
                          // mode: "riego",
                        }
                      },

                      {
                        state: 'vinedo.sectores',
                        itemId: id,
                        label:'Sectores',
                        visible:{
                          // permission: 'ver-vinedo-et'
                          // mode: "riego",
                        }
                      },

                      {
                        state: 'vinedo.huella',
                        itemId: id,
                        label:'Cuarteles',
                        visible:{
                        }
                      },
                      */

                      {
                        state: 'vinedo.estacion',
                        itemId: id,
                        label:'Estación',
                        visible:{
                          // permission: 'ver-vinedo-et':vsp
                          // mode: "riego",
                          config: 'vistaEstacion'
                        }
                      },

          /*
                      {
                        state: 'vinedo.seguimientoIrriview',
                        itemId: id,
                        //label:'Seguimiento',
                        label: 'Analisis Irriview',
                        visible:{
                          // permission: 'ver-vinedo-et'
                          // mode: "riego",
                          //config: 'conSeguimiento'
                        }
                      },
                      */
                      {
                        state: 'vinedo.seguimiento',
                        itemId: id,
                        //label:'Seguimiento',
                        label: 'Analisis',
                        visible:{
                          // permission: 'ver-vinedo-et'
                          // mode: "riego",
                          //config: 'conSeguimiento'
                        }
                      },




                      {
                        state: 'vinedo.mapa',
                        itemId: id,
                        label:'Mapa',
                        visible:{
                          permission: 'ver-mapa',
                          config: 'conMapa'
                        }
                      },

                      {
                        state: 'vinedo.temporadas',
                        itemId: id,
                        label:'temporadas',
                        visible:{
                          // mode: "produccion", //o tambien riego
                          config: 'test'
                        }
                      },
                      {
                        state: 'vinedo.tracking',
                        itemId: id,
                        label: 'Tracking',
                        visible:{
                          // mode: "produccion", //o tambien riego
                          config: 'test'
                        }
                      },
                      {
                        state: 'vinedo.prodres',
                        itemId: id,
                        label:'resumen Prod',
                        visible:{
                          // mode: "produccion", //o tambien riego
                          config: 'test'
                        }
                      },

                      {
                        state: 'vinedo.productividad',
                        itemId: id,
                        label:'Productividad',
                        visible:{
                          // mode: "produccion", //o tambien riego
                          config:'conProduccion'
                          // config: "test"
                        }
                      },

                      {
                        state: 'vinedo.analisis',
                        itemId: id,
                        //label:'Análisis',
                        label: 'Historicos',
                        hidden: true,
                        visible:{
                          // permission: 'ver-vinedo-et'
                          // mode: "riego",
                        }
                      },


                      /*
                      {
                        state: 'vinedo.catastro',
                        itemId: id,
                        label:'Catastro',
                        visible:{}
                      },
                      */

                      // {
                      //   state: 'vinedo.resumen',
                      //   itemId: id,
                      //   label:'Resumen',
                      //   visible:{
                      //     permission: 'ver-vinedo-resumen'
                      //   }
                      // },
                      // deprecated
                      // {
                      //   state: 'vinedo.alertas',
                      //   itemId: id,
                      //   label:'Riegos pendientes'
                      // },                      {


                      /*{
                        state: 'vinedo.et',
                        itemId: id,
                        label:'Datos Climaticos',
                        visible:{
                          // mode: "produccion", //o tambien riego
                          //mode: "riego",
                          permission: 'ver-vinedo-et'
                        }
                      },

          */
                      {
                        state: 'vinedo.sensores',
                        itemId: id,
                        label:'Sensores',
                        visible:{
                          //mode: "riego",
                          permission: 'ver-vinedo-sensores',
                          config: 'conSensores'
                        }
                      },
                      // {
                      //   state: 'vinedo.kc',
                      //   itemId: id,
                      //   label:'Etapas de Riego',
                      //   visible:{
                      //     permission: 'ver-vinedo-kc'
                      //   }

                      // },

                      /*
                      {
                        state: 'vinedo.comparacion',
                        itemId: id,
                        label:'Comparación',
                        visible:{
                          // permission: 'ver-vinedo-et'
                          // mode: "riego",
                        }
                      },
                      {
                        state: 'vinedo.calidades',
                        itemId: id,
                        label:'Calidades',
                        visible:{
                          // mode: "riego", //o tambien riego
                          // mode: "riego",
                          config: 'conCalidad',
                          permission: 'ver-vinedo-calidad'
                        }
                      },
                      {
                        state: 'vinedo.variedades',
                        itemId: id,
                        label:'Variedades',
                        visible:{
                          // mode: "riego",
                          config: 'conVariedad',
                          permission: 'ver-vinedo-variedad'
                        }
                      }
                      */

                      {
                        state: 'vinedo.agroalcubo',
                        itemId: id,
                        label:'Agroalcubo',
                        visible:{
                          //mode: "riego",
                          //permission: 'ver-agroalcubo',
                          config: 'mai'
                        }
                      },

                      {
                        state: 'vinedo.sp',
                        itemId: id,
                        label:'Indices',
                        visible:{
                          //mode: "riego",
                          //permission: 'ver-agroalcubo',
                          config: 'sp_indices'
                        }
                      },

                    ];
      };

      $scope.tabsEquipo = function(id){
        global.tabs = [
                        // {
                        //   state: 'equipo.alertas',
                        //   itemId: id,
                        //   visible: {
                        //     config: 'riegoProgramado',
                        //     permission: 'ver-equipo-alertas'
                        //   },
                        //   label:'Alertas de riego'
                        // },
                        //
                        // {
                        //   state: 'equipo.resumen',
                        //   itemId: id,
                        //   visible:{
                        //     config: 'conScholander',
                        //     permission: 'ver-equipo-resumen'
                        //   },
                        //   label:'Riegos Pendientes'
                        // },

                        {
                          state: 'equipo.timeline',
                          itemId: id,
                          label:'Timeline',
                          visible:{
                            config: 'timelineEquipo',
                            permission: ''
                          }
                        },

                        {
                          state: 'equipo.scholander',
                          itemId: id,
                          visible:{
                            config: 'conScholander',
                            permission: 'ver-equipo-scholander'
                          },
                          label:'Scholander'
                        },

                        {
                          state: 'equipo.programacion',
                          itemId: id,
                          visible:{
                            config: 'riegoProgramado',
                            permission: 'ver-equipo-programacion'
                          },
                          label:'Programación de riego'
                        },

                        {
                          state: 'equipo.real',
                          itemId: id,
                          visible:{
                            config: 'riegoProgramado',
                            permission: 'ver-equipo-real'
                          },
                          label:'Riego Real'
                        },

                      ];
      };

      $scope.tabsCuartel = function(id){
        global.tabs = [
                        {
                          state: 'cuartel.irriview',
                          itemId: id,
                          label:'Irriview',
                          visible:{
                            //permission: 'ver-cuartel-estadisticas'
                          },
                        },

                        {
                          state: 'cuartel.estadisticas',
                          itemId: id,
                          label:'Detalle',
                          visible:{
                            permission: 'ver-cuartel-estadisticas'
                          },
                        },

            /*
                        {
                          state: 'cuartel.comparacion',
                          itemId: id,
                          label:'Comparación',
                          visible:{
                            //permission: 'ver-cuartel-estadisticas'
                          },
                        },
                        {
                          state: 'cuartel.estados',
                          itemId: id,
                          label:'Fenología',
                          visible:{
                            permission: 'ver-cuartel-estados'
                          },
                        },
                        */
                      ];
      };




      // $scope.logout = function () {
      //   Auth.logout(function(){
      //     $state.go("login");
      //     global.clean();
      //     menu.clean();
      //   });
      // };



    /**
     * @ngdoc $on
     *
     * @param {object} "event"       evento
     * @param {object} "toState"     estado de destino
     * @param {object} "toParams"    parametros del estado de destino
     * @param {object} "fromState"   estado de origen
     * @param {object} "fromParams"  parametros del estado de origen
     *
     * @desc evento que detecta el cambio de ruta
     *       al detectar el cambio, cambia los tabs de la vista
     *       y autoselecciona segun la ruta
     */
    $rootScope.$on('$stateChangeStart', function( event, toState, toParams, fromState, fromParams){

      global.exitFullScreen();
      if (angular.isDefined(global.tabApi)) {
        global.tabApi.refreshTabs();
      }else{
        //console.log("no tabs");
      }

      var stateParent = toState.name.split('.')[0];
      var stateFromParent = fromState.name.split('.')[0];

      if(stateFromParent != stateParent || fromParams.id != toParams.id) {
        switch(stateParent){
          case 'vinedo':
            $scope.tabsVinedo(toParams.id, toState);
            break;
          case 'equipo':
            //$scope.tabsEquipo(toParams.id);
          break;
          case 'cuartel':
            $scope.tabsCuartel(toParams.id);
          break;
        }
      }



    /**
    * Funciones para vista de carga
    */
      // var stateParent = toState.name.split('.')[0];
      // var stateFromParent = fromState.name.split('.')[0];
      var nameStateParent = $state.get(stateParent).title;

      if (stateParent != stateFromParent){
        global.loads.showSpinner(stateParent, nameStateParent);
      }
      if (toState.load) {
        global.loads.showSpinner(toState, toState.title);
      }
    }); // END $stateChangeStart



    //solucion temporal a autoseleccion de tabs al refrescar
    $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
      if (angular.isDefined(global.tabApi)) {
          global.tabApi.refreshTabs();
          //if (fromState.name === "") {
            global.tabApi.selectState(toState.name);
          //}

          if (menu.getSidebarProm() == null) {
            //debugger;
          }else{
            //location.reload();
          }
          menu.getSidebarProm().then(function() {
            var stateParent = toState.name.split('.')[0];
            global.selectedVinedo = global.getVinedo(stateParent, toParams.id);
          });

          var firstState = global.tabApi.getFirstValidItem();

        if(toState.redirectTo === undefined){
          if (!global.tabApi.statePermissions(toState.name) && firstState) {
            $state.go(firstState.state);
            console.log("first state");
          }else{
            $timeout(function(){
              var title = "";
              if (global.tabApi.getItemFromStateName(toState.name) !== null) {
                title = global.tabApi.getItemFromStateName(toState.name).label;
              }else{
                title = "";
              }
              global.pestana = global.title + " | " + title;
            }, 100);
          }
        }
      }else{
        console.error("no tabs");
      }

      $timeout(function() {
        global.loads.hideSpinner();
      }, 100);
    }); //END $stateChangeSuccess

      /**********************************************************
       * funciones para manejo de sidebar (TODO depurar codigo) *
       **********************************************************/

        var vm = $scope.vm = this;


        $scope.vm.toggleList = function() {
          var pending = $mdBottomSheet.hide() || $q.when(true);

          pending.then(function(){
            $mdSidenav('left').toggle();
          });
        };

        window.onresize = function(event) {
            // $(window).resize();
            $timeout(function(){
              $rootScope.$broadcast('highchartsng.reflow');
            }, 1000);
        };



        $scope.toggleRightSidenav = function() {
          // Component lookup should always be available since we are not using `ng-if`
          $mdSidenav("right")
          .toggle()
          .then(function () {
            //
          });
        };



      }]);

})();
